import type {
  WProductRecommendationsView,
  WRelatedProductsView,
} from '@zola/svc-web-api-ts-client';
import ApiService from '@zola-helpers/client/dist/es/http/api';

type FetchRecommendedProductsRequest = {
  productId: string;
  skuId: string;
  type?: string[];
  limit?: number;
};

export const fetchRecommendedProducts = (data: FetchRecommendedProductsRequest) => {
  return ApiService.post<WProductRecommendationsView, FetchRecommendedProductsRequest>(
    '/web-registry-api/v1/overview/product/get-recs',
    data
  );
};

type FetchRelatedProductsRequest = {
  productId: string;
};
export const fetchRelatedProducts = ({ productId }: FetchRelatedProductsRequest) => {
  return ApiService.get<WRelatedProductsView>(
    `/web-registry-api/v1/product/find-related/${productId}`
  );
};
